import React, { Component } from 'react';

import './global';
import { Wrapper } from './styles';

import Intro from '../Intro';
import Body from '../Body';
import Footer from '../Footer';

import AppState from '../../states/AppState';

class App extends Component {
  componentDidMount() {
    window.addEventListener('mousemove', this._handleMouseMove);
    window.addEventListener('resize', this._handleWindowResize);
    window.addEventListener('scroll', this._handleWindowScroll);
    this._handleWindowResize();
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this._handleMouseMove);
    window.removeEventListener('resize', this._handleWindowResize);
    window.removeEventListener('scroll', this._handleWindowScroll);
  }

  render() {
    return (
      <Wrapper>
        <Intro />
        <Body />
        <Footer />
      </Wrapper>
    );
  }

  _handleMouseMove = (evt) => {
    AppState.set('mouseX', evt.pageX);
    AppState.set('mouseY', evt.pageY);
  }

  _handleWindowResize = () => {
    const rem = parseInt(getComputedStyle(document.body)['font-size'], 10);
    AppState.set('rem', rem);
    AppState.set('windowWidth', window.innerWidth);
    AppState.set('windowHeight', window.innerHeight);
    AppState.set('bodyHeight', document.body.clientHeight);
  }

  _handleWindowScroll = () => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
    const mouseY = AppState.mouseY - (AppState.scrollTop - scrollTop);
    AppState.set('mouseY', mouseY);
    AppState.set('scrollTop', scrollTop);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js